import React from "react";
import PlanDetail from "src/components/app/PlanDetails";

const PlanDetails:React.FC = ()=>{
  return <PlanDetail />
}

export default PlanDetails;